import React, { Component } from 'react';

import BaseSlider from 'rc-slider';
import 'rc-slider/assets/index.css';

import theme from '../../theme';

const sliderStyle = {
  height: 20,
  marginBottom: 70,
};

const trackStyle = {
  height: 20,
  backgroundColor: theme.primary,
  borderRadius: 0,
};
const railStyle = {
  height: 20,
  backgroundColor: theme.grey,
  borderRadius: 0,
};

const handleStyle = {
  height: 30,
  width: 30,
  borderColor: theme.primary,
  backgroundColor: theme.onPrimary,
};

const dotStyle = {
  width: 4,
  marginLeft: -2,
  height: 20,
  bottom: -16, // step container is not scaled with the rail height
  backgroundColor: theme.primaryAlt,
  border: 0,
  borderRadius: 0,
};

const activeDotStyle = {};

const markStyle = {
  fontSize: '1rem',
  marginTop: 15,
};

const createMarks = ({ min, max, step = 1 }) => {
  const count = (max - min) / step + 1;
  const indices = [...Array(count).keys()];
  const marks = indices.map(i => {
    const value = min + i * step;
    return [
      value,
      {
        style: markStyle,
        label: value,
      },
    ];
  });
  return Object.fromEntries(marks);
};

class Slider extends Component {
  componentDidMount() {
    const { input, defaultValue } = this.props;

    if (input.value === '') {
      this.props.input.onChange(defaultValue);
    }
  }

  render() {
    const {
      input: { value, ...input },
      defaultValue,
      ...other
    } = this.props;
    return (
      <BaseSlider
        style={sliderStyle}
        trackStyle={trackStyle}
        railStyle={railStyle}
        handleStyle={handleStyle}
        dots={true}
        dotStyle={dotStyle}
        activeDotStyle={activeDotStyle}
        marks={createMarks(other)}
        {...other}
        {...input}
        value={value || defaultValue /* workaround for defaultValue */}
      />
    );
  }
}

export default Slider;
